import { Button, Div, Li, P, Strong, Ul } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'
import React from 'react'

interface Props {
  onClose: () => void
  open: boolean
  onToggleAI: () => void
  isAIEnabled: boolean
}

const AIToggleModal = ({ isAIEnabled, onClose, open, onToggleAI }: Props) => {
  const onSubmit = () => {
    onToggleAI()
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      status={isAIEnabled ? 'error' : 'default'}
    >
      <ModalTitle>
        {isAIEnabled
          ? 'Are you sure you want to turn AI off for this playbook?'
          : 'Turn on AI for this playbook?'}
      </ModalTitle>
      <ModalBody>
        {isAIEnabled ? (
          <P style={{ marginTop: 8 }}>
            Please note the following:
            <Ul style={{ marginTop: 0, paddingLeft: 20 }}>
              <Li>
                All paths (including questions, messages, and skills) used
                exclusively by the “All other topics” response will be deleted.
              </Li>
              <Li>
                Your bot will still reply to AI topics that are branched on.
                <Strong>
                  If you have any AI topics in your playbook, please delete them
                  manually to turn off AI entirely.
                </Strong>
              </Li>
            </Ul>
          </P>
        ) : (
          <Div>
            Please keep in mind that <Strong>Content review mode</Strong> is not
            currently supported for AI playbooks.{' '}
          </Div>
        )}
      </ModalBody>
      <ModalFooter
        style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}
      >
        <Button onClick={onClose} type="tertiary">
          {isAIEnabled ? 'Cancel' : 'No, cancel'}
        </Button>
        <Button onClick={onSubmit} type={isAIEnabled ? 'danger' : 'primary'}>
          {isAIEnabled ? 'Turn AI off' : 'Yes, turn on AI'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AIToggleModal
